import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { staffService } from "../../services/staffService";

export const fetchStaff = createAsyncThunk(
  "staff/fetch",
  async (params, { rejectWithValue }) => {
    try {
      const res = await staffService.list(params);
      return res.data.data; // { content, totalElements, totalPages, number }
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Personel yüklenemedi");
    }
  }
);

export const createStaff = createAsyncThunk(
  "staff/create",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await staffService.create(payload);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Personel eklenemedi");
    }
  }
);

export const updateStaff = createAsyncThunk(
  "staff/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const res = await staffService.update(id, payload);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Personel güncellenemedi");
    }
  }
);

export const deleteStaff = createAsyncThunk(
  "staff/delete",
  async (id, { rejectWithValue }) => {
    try {
      await staffService.remove(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Personel silinemedi");
    }
  }
);

export const hardDeleteStaff = createAsyncThunk(
  "staff/hardDelete",
  async (id, { rejectWithValue }) => {
    try {
      await staffService.hardRemove(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Personel kalıcı silinemedi");
    }
  }
);

export const setStaffActive = createAsyncThunk(
  "staff/setActive",
  async ({ id, active }, { rejectWithValue }) => {
    try {
      const res = await staffService.setActive(id, active);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Durum değiştirilemedi");
    }
  }
);

const upsert = (state, updated) => {
  const i = state.items.findIndex((s) => s.id === updated.id);
  if (i !== -1) state.items[i] = { ...state.items[i], ...updated };
};

const staffSlice = createSlice({
  name: "staff",
  initialState: {
    items: [],
    totalElements: 0,
    totalPages: 0,
    page: 0,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearStaffError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStaff.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchStaff.fulfilled, (state, action) => {
        const p = action.payload;
        state.isLoading = false;
        state.items = p.content ?? [];
        state.totalElements = p.totalElements ?? 0;
        state.totalPages = p.totalPages ?? 0;
        state.page = p.number ?? 0;
      })
      .addCase(fetchStaff.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateStaff.fulfilled, (state, action) => upsert(state, action.payload))
      .addCase(setStaffActive.fulfilled, (state, action) => upsert(state, action.payload))
      .addCase(deleteStaff.fulfilled, (state, action) => {
        const i = state.items.findIndex((s) => s.id === action.payload);
        if (i !== -1) state.items[i] = { ...state.items[i], active: false };
      })
      .addCase(hardDeleteStaff.fulfilled, (state, action) => {
        state.items = state.items.filter((s) => s.id !== action.payload);
      });
  },
});

export const { clearStaffError } = staffSlice.actions;
export default staffSlice.reducer;
